import React, { useEffect } from 'react';

/**
 * Query promo code from synaptik and return appropriate copy
 * @param attrs
 */
export const SynaptikPromoCode = ({
  synaptik
}) => {
  const {
    useSynapse
  } = synaptik;
  const [fetchPromotion, promotion] = useSynapse(({
    promotions
  }) => [promotions.fetchPromotion, promotions.state.promotion]);
  useEffect(() => {
    fetchPromotion();
  });
  return promotion && /*#__PURE__*/React.createElement(React.Fragment, null, "Congrats! Promo code applied and a", promotion.discountType === 'dollar' && ` $${promotion.discountAmount} discount will appear at checkout`, promotion.discountType === 'percent' && ` ${promotion.discountAmount}% discount will appear at checkout`);
};